import { render, staticRenderFns } from "./ElBacktop.vue?vue&type=template&id=1807e230"
import script from "./ElBacktop.vue?vue&type=script&lang=js"
export * from "./ElBacktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports